import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ContenidoCtx = createContext({ carta: [], config: null, refresh: () => {} });

export function ContenidoProvider({ children }) {
    const [carta, setCarta] = useState([]);
    const [config, setConfig] = useState(null);

    const refresh = () => {
        api.get("/contenido/carta")
            .then((r) => setCarta(r.data))
            .catch(() => {});
        api.get("/contenido/config")
            .then((r) => setConfig(r.data))
            .catch(() => {});
    };

    useEffect(refresh, []);

    return (
        <ContenidoCtx.Provider value={{ carta, config, refresh }}>
            {children}
        </ContenidoCtx.Provider>
    );
}

export const useContenido = () => useContext(ContenidoCtx);
